export default __webpack_public_path__ + "static/side-navigation.dark-f4546ae77421be48ba29aca321cd807a32488330619b51eeefa825f00b0311b8.png";